import { useEffect, useState } from "react";
import ButtonNext from "../../ButtonNext.svg";
import Pergunta from "./components/Pergunta";
import { dominioHCFamema } from "../../config/database";
import { useNavigate } from "react-router-dom";

export default function TelaPerguntas(props) {
  const [perguntas, setPerguntas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const carregaPerguntas = () => {
    const local = JSON.parse(localStorage.getItem("local"));
    if(local !== null){
      dominioHCFamema
        .get(`/api/listarperguntasporlocal/${local.Id}`)
        .then((response) => {
          setPerguntas(response.data);
        });
    }else {
      const localNovo = JSON.parse(localStorage.getItem("localNovo"));
      navigate(`/${JSON.parse(localNovo.Id)}`)
    }
    
  };

  function operacaoAssincrona(item) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let resposta = "";
        if (item.mb.selected === true) resposta = "MB";
        if (item.bo.selected === true) resposta = "BO";
        if (item.re.selected === true) resposta = "RE";
        if (item.ru.selected === true) resposta = "RU";
        const idIdentificacao = localStorage.getItem("idIdentificacaoPaciente");
        const dados = {
          Resposta: resposta,
          Id_Pergunta: item.Id,
          Id_Identificacao_Resposta: idIdentificacao
        };
        dominioHCFamema.post(`/api/cadastrarresposta`, dados).then(
          () => {},
          (error) => {
            const erro = localStorage.getItem("erro");
            localStorage.setItem(
              "erro",
              JSON.stringify(`${erro} ${error.message}`)
            );
          }
        );
        resolve();
      }, 2000);
    });
  }

  const handleEnviaAvaliacao = async () => {
    setIsLoading(true);
    await Promise.all(
      perguntas.map(async (item) => {
        await operacaoAssincrona(item);
      })
    );
    const erro = localStorage.getItem("erro");
    if (erro) {
      console.log(erro);
      localStorage.removeItem("erro");
      setIsLoading(false);
    } else {
      const localNovo = JSON.parse(localStorage.getItem("local"));
      localStorage.setItem("localNovo", JSON.stringify(localNovo));
      navigate("/agradecimento");
    }
  };

  const handleClickItem = (type, index, item) => {
    const updatedItem = {
      ...item,
      mb: { ...item.mb, selected: false },
      bo: { ...item.bo, selected: false },
      re: { ...item.re, selected: false },
      ru: { ...item.ru, selected: false },
    };

    switch (type) {
      case "mb":
        updatedItem.mb.selected = !item.mb.selected;
        break;
      case "bo":
        updatedItem.bo.selected = !item.bo.selected;
        break;
      case "re":
        updatedItem.re.selected = !item.re.selected;
        break;
      case "ru":
        updatedItem.ru.selected = !item.ru.selected;
        break;
      default:
        break;
    }
    const novaLista = [...perguntas]; // Cria uma cópia da lista original

    novaLista[index] = updatedItem; // Substitui o item no índice especificado

    setPerguntas(novaLista);
  };

  useEffect(() => {
    carregaPerguntas();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        marginTop: "40px",
      }}
    ><h1 style={{
      fontSize: '18px',
      margin: '12px 2px 12px 2px'
    }}>Clique em cada item para avaliar.</h1>
      {perguntas?.map((item, index) => (
        <Pergunta item={item} handleClickItem={handleClickItem} index={index} />
      ))}
      <h1 style={{
      fontSize: '18px',
      margin: '12px 30px 2px 30px'
    }}>Clique em enviar para finalizar sua avaliação.</h1>
      <button
        style={{
          borderRadius: "5px",
          widht: "135px",
          height: "30px",
          margin: "60px 112px",
          border: "none",
          backgroundColor: "#0F779A",
          color: "white",
          padding: "5px 43px",
        }}
        onClick={() => handleEnviaAvaliacao()}
        disabled={isLoading}
      >
        {isLoading ? 'Carregando...' : 'Enviar'}
      </button>
    </div>
  );
}
